import XeroConnectButtonIcon from './XeroConnectButtonIcon';

export default XeroConnectButtonIcon;
